<template>
  <div
    class="air-box"
    ref="air"
  >
    <img
      class="png"
      :src="require('@/assets/images/lucht-first-frame.png')"
      draggable="false"
    />
    <img
      class="gif"
      v-if="blown && inView"
      :src="require('@/assets/images/lucht.gif')"
      draggable="false"
    />
    <button :class="buttonClasses">Houd ingedrukt om op te blazen</button>
  </div>
</template>

<script>
import Hammer from 'hammerjs'
import { trackAir } from '@/utils/track'
import { scrollPositionMixin } from '@/mixins'

export default {
  name: 'AirBox',
  data () {
    return {
      blown: false
    }
  },
  mounted () {
    const hammer = new Hammer(this.$refs.air)
    hammer.get('press').set({
      threshold: 12,
      time: 500
    })
    hammer.on('press', () => {
      this.blown = true
      trackAir()
    })
  },
  computed: {
    buttonClasses () {
      return {
        'button': true,
        'is-blown': this.blown
      }
    }
  },
  mixins: [scrollPositionMixin]
}
</script>

<style lang="scss" scoped>
.air-box {
  position: relative;
  padding-bottom: 2em;
  cursor: pointer;
  text-align: center;
}

.png {
  width: 100%;
}

.gif {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.button {
  background-color: $c-red;
  display: inline-block;
  color: white;
  border: none;
  padding: 11px 16px 15px;
  line-height: 1;
  border-radius: 25px;
  font-weight: $fw-medium;
  border-bottom: 4px solid #A31411;
  margin: 1.5em auto 0;
  text-align: center;
  cursor: pointer;
  transition: all 500ms ease;
  outline: 0;
  animation: pulse 2s infinite;

  &:active {
    transform: scale(0.95);
  }
}

.is-blown {
  background-color: #A31411;
  opacity: 0.5;
  animation: none;
}
</style>
